<template>
    <div id="cancel-accept-plane-buttons" class="lb-btn-container">
        <div class="grey-outline-pill-button" v-on:click="cancel">Отменить</div>
        <div class="red-pill-button-of-hate go-next extra-left-margin" v-on:click="accept">Готово</div>
    </div>
</template>

<script>
    import {bus} from "../../../vue_bus";

    export default {
        name: "RightLowerBarEditGroupConfirmation",
        props: {
            version: {
                type: String
            }
        },
        computed: {
            activeStep() {
                return this.$store.state.route.name
            },
            adjacentSteps() {
                let stepsOrder = this.$store.state.UI.stepsChain[this.version].stepsOrder
                return stepsOrder[this.activeStep]
            }
        },
        methods: {
            accept () {
                const newPlaneGroupSettings = this.$store.getters["UI/planeGroupSettings/VALUE_PARAMS"];
                this.$store.dispatch('active/UPDATE_VALUE_PARAMS', newPlaneGroupSettings);
                bus.$emit("AcceptPlaneGrouping");
                this.$router.push({
                  name: this.adjacentSteps.prev,
                  query: this.$route.query,
                }).catch(() => {});

            },
            cancel() {
                this.$router.push({
                  name: this.adjacentSteps.prev,
                  query: this.$route.query,
                }).catch(() => {})
            }
        }
    }
</script>

<style scoped>

</style>
